import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { menuBtn, searchBtn, cartBtn, cartCount } = zelektor(node)
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    menuBtn.addEventListener('click', openMenu)
    
    searchBtn.addEventListener('click', () => {
        ctx.emit('search:open')
    })

    cartBtn.addEventListener('click', e => {
        e.preventDefault()
        toggleCartDrawer(e)
    })

    ctx.on('gender:set', ({gender}) => {
        setGender(gender)
    })

    ctx.on('cart:updated', (state) => {
        updateCartCount(state.cart.item_count)  
    })


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function init() {
        if (gender) setGender(gender)
        updateCartCount(ctx.getState().cart.item_count)
    }

    function openMenu() {
        ctx.emit('menu:toggle')
    }

    function toggleCartDrawer(e) {
        e.preventDefault()

        ctx.emit('cart:toggle', state => {
            return {
                cartOpen: !state.cartOpen,
            }
        })
    }

    function setGender(gender) {
        node.classList.remove('gender--women')
        node.classList.remove('gender--men')
        node.classList.remove('gender--unisex')

        node.classList.add(`gender--${gender}`)
    }
    function updateCartCount(count) {
        count > 0 ? cartCount.innerText = count : cartCount.innerText = ''
    }
})